<style scoped lang="scss" type="text/scss">
    .file-download-panel-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 5rem;
        box-sizing: border-box;
        height: 2rem;
        font-size: .75rem;
        background-color: #417DFF;
        color: #FFF;
        transition: all .2s;
        border-bottom-left-radius: .15rem;

        .icon {
            margin-right: .25rem;
        }

        &:hover {
            cursor: pointer;
            transform: scale(1.1);
        }
    }
</style>

<style lang="scss" type="text/scss">
    .download-panel.check-boxes {
        width: 11rem;

        .vertical-check-item {
            margin-top: .25rem;
            width: 100%;

            &:first-of-type {
                margin-top: 0;
            }
        }
    }
</style>

<template>
    <el-popover
            placement="bottom"
            trigger="click">
      <el-select
          v-model="yearValue"
          placeholder="Select"
          size="small"
          style="width: 11rem"
      >
        <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        />
      </el-select>
        <div class="download-panel check-boxes">
            <el-checkbox v-for="item in items" size="small" :key="item.key" v-model="option[item.key]"
                         class="vertical-check-item"
                         :label="item.title" border>
            </el-checkbox>
            <el-button type="primary" plain style="width: 100%; margin-top: .25rem" size="mini"
                       @click="download" :loading="requesting" :disabled="allFalse"
            >
                确认导出
            </el-button>
        </div>

        <div class="file-download-panel-container" slot="reference">
            <i class="icon">&#xe6b0;</i>
            <span>下载</span>
        </div>
    </el-popover>
</template>

<script>
    export default {
        name: '',
        data () {
            return {
              yearValue: "",
              options : [
                {value: '2030',label: '2030',},
                {value: '2029',label: '2029',},
                {value: '2028',label: '2028',},
                {value: '2027',label: '2027',},
                {value: '2026',label: '2026',},
                {value: '2025',label: '2025',},
                {value: '2024',label: '2024',},
                {value: '2023',label: '2023',},
                {value: '2022',label: '2022',},
                {value: '2021',label: '2021',},
                {value: '2020',label: '2020',},
                {value: '2019',label: '2019',},
                {value: '2018',label: '2018',},
                {value: '2017',label: '2017',},
                {value: '2016',label: '2016',},
                {value: '2015',label: '2015',},
                {value: '2014',label: '2014',},
                {value: '2013',label: '2013',},
                {value: '2012',label: '2012',},
                {value: '2011',label: '2011',},
                {value: '2010',label: '2010',},
                {value: '2009',label: '2009',},
                {value: '2008',label: '2008',},
                {value: '2007',label: '2007',},
                {value: '2006',label: '2006',},
                {value: '2005',label: '2005',},
                {value: '2004',label: '2004',},
                {value: '2003',label: '2003',},
                {value: '2002',label: '2002',},
                {value: '2001',label: '2001',},
              ],

              requesting: false,
                option: {
                    all_year_player: true,
                },
                items: [
                    {
                        title: '该届所有参赛队.xls',
                        key: 'all_year_player'
                    },
                ]
            };
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            },
            allFalse () {
                const option = this.option;
                let allFalse = true;
                for (const key in option) {
                    if (option[key] === true) allFalse = false;
                }
                return allFalse;
            }
        },
        methods: {
            download () {
                if (this.yearValue === "") {
                  return;
                }
                this.$normalRequest('player/downloadCollectDataZip', {
                    ...this.option,
                    competition_id: this.currentCompetitionId,
                    year_value: this.yearValue
                }, false, false, this, 'requesting').then(data => {
                    this.$download(data);
                }).catch(_ => {
                });
            }
        }
    };
</script>
